export default __webpack_public_path__ + "static/media/logo.5ba5fbe3.png";